/**
 * Dopuszczalne masy na osiach dla zwykłego Mercedes Benz Tourist Line
 * (Sekcja 16.2 / 17.2 - Technically permissible maximum mass on each axle) -
 * patrz vehicle-axle-mass-limits.ts po strukturę i uogólnioną funkcję
 * odczytującą (getAxleMassLimit). Ten plik zawiera wyłącznie dane tej
 * zabudowy.
 *
 * W przeciwieństwie do Iveco / MB HighDeck kluczem pierwszego poziomu NIE
 * jest tonaż, tylko kod masy pojazdu ({{versionMassCode}}, "C" albo "F") -
 * ta zabudowa różnicuje osie wyłącznie wg dopuszczalnej masy całkowitej
 * (C = 5500 kg, F = 6100 kg). Oznaczenie skrzyni/napędu nie ma tu znaczenia
 * - wszystkie wpisy pod kluczem "*" (ten sam wzorzec "brak drugiego wymiaru"
 * co w MB HighDeck).
 *
 * 17.2 (intendedMaxMassAxle1/2) = dokładnie te same wartości co 16.2.
 *
 * @module mercedes-tourist-line-axle-mass-limits
 */

import type { AxleMassLimitTable } from "./vehicle-axle-mass-limits";

export const MERCEDES_TOURIST_LINE_AXLE_MASS_LIMITS: AxleMassLimitTable = {
  // MASA 5500 (kod C)
  C: {
    "*": { axle1: 2000, axle2: 3800 },
  },
  // MASA 6100 (kod F)
  F: {
    "*": { axle1: 2000, axle2: 4200 },
  },
};
